module.exports = __webpack_public_path__ + "img/green-t-shirt.b3ccad35.jpg";